export default class MailViewerRecipientsController {
	/* @ngInject */
	constructor() {
		this.expand = false;
		this.recipient = undefined;
		this.recipients = undefined;
	}

	$onChanges(changes) {
		if (changes.recipient) {
			this.recipients = Array.isArray(this.recipient) ? [...this.recipient] : [{ ...this.recipient }];
			this.recipients.map(recipient => {
				if (recipient) {
					if (recipient.email) {
						// Remove unwanted characters
						recipient.email = recipient.email.replace(/[^\w!#$%&'*+-/=?@^`{|}~-]/gi, '');
					}

					if (!recipient.name && recipient.email) {
						recipient.name = recipient.email;
					}
				}

				return recipient;
			});
		}
	}
}
